// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationPhoneInfoDto
 */
export interface IOrganizationPhoneInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPhoneInfoDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPhoneInfoDto
     */
    phone_extension?: string;
}

/**
 * Check if a given object implements the IOrganizationPhoneInfoDto interface.
 */
export function instanceOfIOrganizationPhoneInfoDto(value: object): value is IOrganizationPhoneInfoDto {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function IOrganizationPhoneInfoDtoFromJSON(json: any): IOrganizationPhoneInfoDto {
    return IOrganizationPhoneInfoDtoFromJSONTyped(json, false);
}

export function IOrganizationPhoneInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationPhoneInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'phone_extension': json['phone_extension'] == null ? undefined : json['phone_extension'],
    };
}

export function IOrganizationPhoneInfoDtoToJSON(json: any): IOrganizationPhoneInfoDto {
    return IOrganizationPhoneInfoDtoToJSONTyped(json, false);
}

export function IOrganizationPhoneInfoDtoToJSONTyped(value?: IOrganizationPhoneInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'phone_extension': value['phone_extension'],
    };
}

